import { render, staticRenderFns } from "./describe.vue?vue&type=template&id=642445f4&scoped=true"
import script from "./describe.vue?vue&type=script&lang=js"
export * from "./describe.vue?vue&type=script&lang=js"
import style0 from "./describe.vue?vue&type=style&index=0&id=642445f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_abc276eb37b0b1314bfe9ec856cc5e10/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642445f4",
  null
  
)

export default component.exports